import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Booking from "./Booking";
import FileSettings from "./FileSettings";
import GeneralSettings from "./GeneralSettings";
import ManageConsent from "./ManageConsent";
import Monitoring from "./Monitoring";
import NewsPost from "./NewsPost";
import OneStream from "./OneStream";
import OrderingSystem from "./OrderingSystem";
import Procurement from "./Procurement";

const SiteRoles = ({
  colorSchemes,
  disabled,
  handleCheckbox,
  handleOpenColorSets,
  handleSelect,
  roleSubscriptionLevel,
  settingValues,
  siteRoleValues,
}) => {
  return (
    <Grid container spacing={1}>
      {settingValues.booking && (
        <Booking
          disabled={disabled}
          handleCheckbox={handleCheckbox}
          roleSubscriptionLevel={roleSubscriptionLevel}
          siteRoleValues={siteRoleValues}
        />
      )}

      {settingValues.manageConsent && (
        <ManageConsent
          disabled={disabled}
          handleCheckbox={handleCheckbox}
          roleSubscriptionLevel={roleSubscriptionLevel}
          siteRoleValues={siteRoleValues}
        />)
      }

      {settingValues.monitoring && (
        <Monitoring
          disabled={disabled}
          handleCheckbox={handleCheckbox}
          roleSubscriptionLevel={roleSubscriptionLevel}
          siteRoleValues={siteRoleValues}
        />
      )}

      {settingValues.newsPost && (
        <NewsPost
          disabled={disabled}
          handleCheckbox={handleCheckbox}
          roleSubscriptionLevel={roleSubscriptionLevel}
          siteRoleValues={siteRoleValues}
        />
      )}

      {settingValues.documentCollaboration && (
        <FileSettings
          colorSchemes={colorSchemes}
          disabled={disabled}
          handleCheckbox={handleCheckbox}
          handleOpenColorSets={handleOpenColorSets}
          handleSelect={handleSelect}
          roleSubscriptionLevel={roleSubscriptionLevel}
          siteRoleValues={siteRoleValues}
        />
      )}

      {settingValues.workSpaceSettings && (
        <GeneralSettings
          disabled={disabled}
          handleCheckbox={handleCheckbox}
          roleSubscriptionLevel={roleSubscriptionLevel}
          siteRoleValues={siteRoleValues}
        />
      )}

      {settingValues.oneStream && (
        <OneStream
          disabled={disabled}
          handleCheckbox={handleCheckbox}
          roleSubscriptionLevel={roleSubscriptionLevel}
          siteRoleValues={siteRoleValues}
        />
      )}

      {settingValues.orderingModule && (
        <OrderingSystem
          disabled={disabled}
          handleCheckbox={handleCheckbox}
          handleSelect={handleSelect}
          roleSubscriptionLevel={roleSubscriptionLevel}
          siteRoleValues={siteRoleValues}
        />
      )}

      {settingValues.procurement && (
        <Procurement
          disabled={disabled}
          handleCheckbox={handleCheckbox}
          roleSubscriptionLevel={roleSubscriptionLevel}
          siteRoleValues={siteRoleValues}
        />
      )}
    </Grid>
  );
};

SiteRoles.propTypes = {
  colorSchemes: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
  handleCheckbox: PropTypes.func.isRequired,
  handleOpenColorSets: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  settingValues: PropTypes.shape({
    booking: PropTypes.bool,
    documentCollaboration: PropTypes.bool,
    monitoring: PropTypes.bool,
    newsPost: PropTypes.bool,
    orderingModule: PropTypes.bool,
    procurement: PropTypes.bool,
    workSpaceSettings: PropTypes.bool,
  }),
  siteRoleValues: PropTypes.shape({}),
};

SiteRoles.defaultProps = {
  colorSchemes: [],
  disabled: false,
  settingValues: {},
  siteRoleValues: {},
};

SiteRoles.displayName = "SiteRoles";

export default SiteRoles;
